import styled from "styled-components";

const { ButtonOutline } = require("src/components");

const StyledButton = styled(ButtonOutline)`

  &:not(:hover) {
    background-color: ${({ selected }) => (selected ? "#035eba" : "transparent")};
    color: ${({ selected }) => (selected ? "white" : "#035eba")};
  }
`;

const SelectButton = ({ option, onClick, selected,...rest }) => {
  const { title, subtitle, value } = option;

  return (
    <StyledButton
      className="p-3"
      selected={selected}
      onClick={() => onClick(value)}
      {...rest}
    >
      <>
        <h4>{title}</h4>
        <p style={{ fontWeight: "lighter" }} className="mb-0">
          {subtitle}
        </p>
      </>
    </StyledButton>
  );
};

export default SelectButton;
